import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';

const listItems = (functions, type) => {
  const filtered = functions.filter((func) => !func.types || (func.types && func.types.includes(type)));
  return filtered.map((func) => ({
    key: `pmn_functions_${func.code}`,
    text: func.name,
    value: func.code,
  }));
};

const DictionaryFieldPmnFunctionDropdown = ({
  onChange,
  pmnFunctions,
  type,
  code,
  isLoading,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      className="aridhia-dictionary-field-pmn-functions-dropdown selection aridhia-is-edit-mode"
      placeholder={intl.formatMessage({ id: 'dataset.dictionary.field.pmn.rule.placeholder' })}
      loading={isLoading}
      value={code}
      fluid
      onChange={(e, { value }) => { onChange(value); }}
      options={listItems(pmnFunctions, type)}
    />
  );
};
export default DictionaryFieldPmnFunctionDropdown;
